'use client';

import { MarketoForm } from '@/components/ui/marketo-form';
import { MarketoScript } from '@/components/ui/marketo-form/components/marketo-script';

type EmbeddedFormProps = {
  anchorId?: string;
  formId: number;
  slugId: string;
  badge?: string;
  title?: string;
  description?: string;
  successTitle?: string;
  successDescription?: string;
  successCTA?: {
    label?: string;
    url?: string;
    type?: 'Button' | 'Link';
  };
  thankYouUrl?: string;
  greyBackground?: boolean;
  greyBorder?: boolean;
};

export const EmbeddedForm = ({
  anchorId,
  formId,
  slugId,
  badge,
  title,
  description,
  successTitle,
  successDescription,
  successCTA,
  thankYouUrl,
  greyBackground,
  greyBorder,
}: EmbeddedFormProps) => {
  return (
    <div
      id={anchorId || undefined}
      style={{
        maxWidth: 580,
        margin: '0 auto',
        ...(greyBackground && { background: '#f5f5f5' }),
        ...(greyBorder && { border: '1px solid #e5e7eb', borderRadius: 8 }),
        ...((greyBackground || greyBorder) && { padding: 24 }),
      }}
    >
      <MarketoScript baseUrl="//info.onceforall.com" />
      <MarketoForm
        formId={formId}
        formContent={{
          formId,
          slugId,
          badge,
          title,
          description,
          successTitle,
          successDescription,
          successCTA,
          thankYouUrl,
        }}
        thankYouUrl={thankYouUrl}
      />
    </div>
  );
};
